import { Dispatch } from 'react';
import { Lot } from 'types';
import { LineItemsAction } from '@providers/LineItemsProvider/action_types';
import { EXPAND_ALL } from '@providers/LineItemsProvider/constants';

interface CollapsedLotsProps {
  dispatch: Dispatch<LineItemsAction>;
  lots?: Lot[];
  searchValue: string;
}

export const trackCollapsedLots = ({ lots, searchValue, dispatch }: CollapsedLotsProps)   => {
  if (!lots?.length) return;

  if (searchValue === '') {
    dispatch({ type: EXPAND_ALL });
  }
};
